import axios from '../shared/axios';

export function SaveAISettings(data) {
    return axios.post('/api/AISettings/SaveAISettings', data);
}

export function GetAISettings(type, referenceId) {
    return axios.get(`/api/AISettings/GetAISettings?type=${type}&referenceId=${referenceId}`);
  }

export function AISettingsToSelectList(type) {
return axios.get(`/api/AISettings/AISettingsToSelectList?type=${type}`);
}